/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import {Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TimeFormatPipe } from 'app/core/pipes/timeFormat.pipe';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { concat, Observable, of, Subject, Subscription } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import _ from 'lodash';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { TimesheetsService } from 'app/core/services/timesheets/timesheets.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import moment from 'moment';
import { HotToastService } from '@ngneat/hot-toast';
import { NewTimeOff } from './new-timeoff.interface';
import dayjs from 'dayjs';
import { calendarModule } from '../datagrid/datagrid.interface';
@Component({
    selector: 'new-timeoff',
    templateUrl: './new-timeoff.component.html',
    styleUrls: ['./new-timeoff.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class NewTimeOffComponent implements OnInit, OnDestroy {
    action: 'create' | 'edit' | 'prefill' = 'create';
    timeoffFormGroup: UntypedFormGroup;
    dateFormat: string = 'DD/MM/YYYY';
    timeformat: string = 'HH:mm:ss';
    listValue$: Observable<any> = new Observable<any>();
    valueSubject$: Subject<string | null> = new Subject<string | null>();
    lookupLoading: boolean = false;
    pageSize: number = 1;
    searchTerm: string = '';
    teams: Array<any> = [];
    reasonOptions: Array<any> = [
        {
            name:'Default',
            reasons: [{key:'Vacation', value: 'VACATION'},
            {key:'Sick', value: 'SICK'},
            {key:'Parental Leave', value: 'PARENTAL LEAVE'},
            {key:'Unpaid', value: 'UNPAID'},
            {key:'Others', value: 'OTHERS'}]
        }
    ];
    requestTypes: Array<{key: string;value: string}> = [];
    applyPartial: boolean = true;
    datePickerSubscription: Subscription;
    endDatePickerSubscription: Subscription;
    timePickerSubscription: Subscription;
    toTimePickerSubscription: Subscription;
    preloadedValue: any = [];
    disableUserAndTeamPicker: boolean = false;
    timezone: string;
    timezoneDisplayName: string = '';
    dialogTitle: string = '';
    defaultDateTimeFormat: string = 'YYYY-MM-DD HH:mm:Ss';

    constructor( @Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<NewTimeOffComponent>,
                private formBuilder: UntypedFormBuilder,
                private utilityService: UtilityService,
                private timeFormatPipe: TimeFormatPipe,
                private dataCollectorService: DataCollectorService,
                private timesheetsService: TimesheetsService,
                private localStorageService: LocalStorageService,
                private toast: HotToastService){}

    ngOnInit(): void {
        let startDate: any = moment();
        let startTime: any = this.getBusinessHours('start');
        let endDate: any = moment();
        let endTime: any = this.getBusinessHours('end');
        let user: any = null;
        let team: any = null;
        let reason: any = null;
        let remarks: any = '';
        this.getRequestType();
        this.dateFormat = this.utilityService.dateFormat;
        this.timeformat = this.utilityService.timeFormat;
        this.action = this.data?.action || 'create';
        this.disableUserAndTeamPicker = this.action === 'edit' || this.action === 'prefill';
        this.dialogTitle = this.getDialogTitle();
        if((this.action === 'prefill' || this.action === 'edit') && this.data.timeoffData) {
            this.applyPartial = false;
            this.timezone = this.data?.timeoffData?.timezone || this.timezone;
            this.timezoneDisplayName = this.utilityService.getTimezoneDisplayName(this.timezone);
            startDate = this.data.timeoffData.startDate;
            endDate = this.data.timeoffData.endDate;
            startTime = this.data.timeoffData.startTime;
            endTime = this.data.timeoffData.endTime;
            user = this.data.timeoffData.user.user_uid;
            team = this.data.timeoffData.team.team_uid;
            reason = this.data.timeoffData?.reasonUid;
            remarks = this.data.timeoffData.remarks || '';
        }

        this.timeoffFormGroup = this.formBuilder.group({
            from_date: [moment(startDate).tz(this.timezone), [Validators.required]],
            from_time_field: [moment(startTime, 'HH:mm:ss').format(this.timeformat)],
            from_time_picker: [moment(startTime, 'HH:mm:ss')],
            to_date: [moment(endDate).tz(this.timezone), [Validators.required]],
            to_time_field: [moment(endTime, 'HH:mm:ss').format(this.timeformat), endTimeValidator()],
            to_time_picker: [moment(endTime,'HH:mm:ss')],
            user: [user,[Validators.required]],
            team: [team],
            reason: [reason, [Validators.required]],
            request_type:  [{value:null,disabled:true}],
            remarks: [remarks],
            notify_user: [true]
        });
        this.datePickerSubscription = this.timeoffFormGroup.controls.from_date.valueChanges.subscribe((response: any)=>{
            this.timeoffFormGroup.controls.to_date.setValue(null);
        });

        this.endDatePickerSubscription = this.timeoffFormGroup.controls.to_date.valueChanges.subscribe((response: any)=>{
            this.timeoffFormGroup.controls.to_time_field.updateValueAndValidity();
        });

        this.timePickerSubscription = this.timeoffFormGroup.controls.from_time_picker.valueChanges.subscribe((response: any)=>{
            this.timeoffFormGroup.controls.from_time_field.setValue(response.format(this.timeformat));
        });
        this.toTimePickerSubscription = this.timeoffFormGroup.controls.to_time_picker.valueChanges.subscribe((response: any)=>{
            this.timeoffFormGroup.controls.to_time_field.setValue(response.format(this.timeformat));
        });

        const loggedInUser = this.localStorageService.getLocalStorage('user');
        if ((this.action === 'prefill' || this.action === 'edit') && this.data.timeoffData) {
            this.listValue$ = of(this.constructLookupList([this.data.timeoffData.user]));
            this.teams = [{team_uid: this.data.timeoffData.team.team_uid, team_name: this.data.timeoffData.team.team_name}];
            this.timeoffFormGroup.controls.user.setValue(this.data.timeoffData.user.user_uid);
            this.timeoffFormGroup.controls.team.setValue(this.data.timeoffData.team.team_uid);
        }
        else if(loggedInUser?.role?.role_key === 'FIELD_EXECUTIVE'){
            const dataUrl = `${this.dataCollectorService.baseurl()}/user/all`;
            const paramObj = {
                'page': this.pageSize,
                'filter.is_assigned_to_team': true,
                'populate_teams': true,
                'filter.user_uid': loggedInUser?.user_uid
            };
            this.dataCollectorService.getData(dataUrl,paramObj)
            .subscribe((response: any) => {
                this.lookupLoading = false;
                this.listValue$ = of(this.constructLookupList(response.data));
                this.teams = response?.data[0]?.teams;
                this.timeoffFormGroup?.controls?.user?.setValue(loggedInUser?.user_uid);
                this.timeoffFormGroup?.controls?.user.disable();
                if(this.teams?.length > 0){
                    this.timeoffFormGroup.controls.team.setValue(this.teams[0]?.team_uid);
                }
                if( this.teams?.filter((data: any)=>data.team_uid === this.timeoffFormGroup.controls.team.value)?.length === 0){
                    this.timeoffFormGroup.controls.team.setValue(null);
                }
            });
        }else{
            this.setPreLoadedValueToLookUp();
        }
    };

    setPreLoadedValueToLookUp(): any {
        const fieldValueURL = '/user/all';
        const dataUrl = `${this.dataCollectorService.baseurl()}${fieldValueURL}`;
        const paramObj = {
            'page': this.pageSize,
            'filter.is_assigned_to_team': true
          };
        return this.dataCollectorService.getData(dataUrl,paramObj)
          .subscribe((response: any) => {
            this.preloadedValue = this.preloadedValue?.length
              ? [
                  ...this.preloadedValue,
                  ...this.constructLookupList(response.data),
                ]
              : this.constructLookupList(response.data);
            this.lookupLoading = false;
            this.loadLookupValues();
          });
      }

    getRequestType(): void{
        this.dataCollectorService.getData(this.timesheetsService.requestTypeUrl).subscribe((response: any)=>{
            if(response.data.length){
                this.requestTypes = response.data.map((type: any)=>({key:type.name, value:type.timeoff_request_type_uid}));
                this.reasonOptions = [...this.reasonOptions,{name:'Custom', reasons : this.requestTypes}];
            }
        });
    }

    getBusinessHours(type): any{
        if(type === 'start'){
            return this.localStorageService.getLocalStorage('company_configuration_data')?.business_hours?.start_time || '00:00:00';
        }else if(type === 'end'){
            return this.localStorageService.getLocalStorage('company_configuration_data')?.business_hours?.end_time || '24:00:00';
        }
    }

    onformSubmit(): void{
        this.timeoffFormGroup.markAllAsTouched();
        let fromDate = `${this.timeoffFormGroup.controls.from_date.value.format('YYYY-MM-DD')} ${this.applyPartial ? this.getBusinessHours('start') : dayjs(this.timeoffFormGroup.controls.from_time_field.value,this.utilityService.timeFormat).format('HH:mm:ss')}`;
        let toDate = `${this.timeoffFormGroup.controls.to_date.value.format('YYYY-MM-DD')} ${this.applyPartial ? this.getBusinessHours('end') : dayjs(this.timeoffFormGroup.controls.to_time_field.value,this.utilityService.timeFormat).format('HH:mm:ss')}`;
        fromDate = dayjs.tz(fromDate, this.timezone).utc().format('YYYY-MM-DD HH:mm:ss');
        toDate = dayjs.tz(toDate, this.timezone).utc().format('YYYY-MM-DD HH:mm:ss');
        const defaultReasonIndex = this.reasonOptions.filter((group: any)=> group.name === 'Default')[0]?.reasons?.findIndex((data: any)=> data.value === this.timeoffFormGroup.value.reason);

        let payload: NewTimeOff = {
            'timeoff_request':{
                'request_from':fromDate,
                'request_to':toDate,
                'team_uid': this.timeoffFormGroup.value.team,
                'user_uid':this.timeoffFormGroup.value.user,
                'request_reason':defaultReasonIndex >= 0 ? this.timeoffFormGroup.value.reason : 'CUSTOM',
                'request_remarks': this.timeoffFormGroup.value.remarks,
                'all_day': this.applyPartial,
                'notify_user': this.timeoffFormGroup.value.notify_user
            }
         };

         if(defaultReasonIndex === -1){
            payload = { timeoff_request : {
                ...payload?.timeoff_request,
                'request_type': this.timeoffFormGroup.value.reason
                }};
         };

        if (this.timeoffFormGroup.valid) {
            if (this.action === 'create' || this.action === 'prefill') {
                this.toast.loading(this.utilityService.getLocaleValue('newtimeoff.apply.loading.message', 'Applying Time Off'), { id: 'timeoff loading' });
                this.dataCollectorService.postData(this.timesheetsService.timeoffUrl, payload).subscribe((response: any) => {
                    this.toast.close('timeoff loading');
                    if (response.type === 'success') {
                        this.toast.success(response.message);
                        this.dialogRef.close({ status: true, request_uid: response.data.request_uid });
                        this.utilityService.updateNewTimeoff(calendarModule.CONFIRMED);
                    }
                }, (error: any) => {
                    this.toast.close('timeoff loading');
                });
            }
            else if(this.action === 'edit' && this.data.timeoffData.request_uid) {
                const editTimeOffUrl = `${this.dataCollectorService.baseurl()}/timesheets/request/timeoff/${this.data.timeoffData.request_uid}`;
                this.toast.loading(this.utilityService.getLocaleValue('editTimeoff.apply.loading.message', 'Editing Time Off'), { id: 'timeoff loading' });
                this.dataCollectorService.putData(editTimeOffUrl, payload).subscribe((response: any) => {
                    this.toast.close('timeoff loading');
                    if (response.type === 'success') {
                        this.toast.success(response.message);
                        this.dialogRef.close({ status: true, request_uid: response.data.request_uid });
                        this.utilityService.updateNewTimeoff(calendarModule.CONFIRMED);
                    }
                }, (error: any) => {
                    this.toast.close('timeoff loading');
                });
            }
        }
    };

    getMeridian(): boolean{
        return this.timeformat === 'hh:mm A';
    };

    constructLookupList(data): any{
        const template = _.template('{{first_name}} {{last_name}}');
        const returnValue = data.map((key: any)=>({...key,bindLabel:template(key)}));
        return returnValue;
    }

    setListValue(term): any{
        if([null,undefined].includes(term)){
            this.lookupLoading = false;
            return of(null);
          }
        const fieldValueURL = '/user/all';
        const dataUrl = `${this.dataCollectorService.baseurl()}${fieldValueURL}`;
        const paramObj = {
            'page': this.pageSize,
            'filter.keyword': term,
            'filter.is_assigned_to_team': true
          };
        return this.dataCollectorService.getData(dataUrl,paramObj)
        .pipe(map((response: any)=>this.constructLookupList(response.data)
        ));
    }

    onUserValueChange(event): void{
        if(event){
            this.timeoffFormGroup.controls.user.setValue(event?.user_uid);
            this.dataCollectorService.getData(this.timesheetsService.getTeamsBasedOnUser(event.user_uid)).subscribe((response: any)=>{
                this.teams = response.data;
               if(this.teams.length > 0){
                this.timeoffFormGroup.controls.team.setValue(this.teams[0]?.team_uid);
               }
               if( this.teams?.filter((data: any)=>data.team_uid === this.timeoffFormGroup.controls.team.value)?.length === 0){
                this.timeoffFormGroup.controls.team.setValue(null);
               }
            });
        }else if(this.utilityService.isEmptyOrUndefined(event)){
            this.teams = [];
            this.timeoffFormGroup.controls.team.setValue(null);
        }
    }

    onSelectionChange(event): void{
        const currentValue = event?.value;
        this.timeoffFormGroup.controls.reason.setValue(null);
        this.timeoffFormGroup.controls.reason.setValue(currentValue);
    }

    public loadLookupValues(): any {
        this.lookupLoading = false;
        this.listValue$ = concat(
            of(this.preloadedValue),this.valueSubject$.pipe(
                debounceTime(500),
                distinctUntilChanged(),
                tap(() => this.lookupLoading = true),
                switchMap((term: any) => {
                    if(!['',null,undefined].includes(term)){
                    return this.setListValue(term).pipe(
                    catchError(() => of(this.preloadedValue)),
                        tap(() => this.lookupLoading = false)
                        );
                    }else {
                        this.lookupLoading = false;
                    return [];
                    }
                    }))
        );
    }

    getDialogTitle(): string {
        let dialogTitle: string = this.utilityService.getLocaleValue('new.time.off.dialog.title', 'Create New Timeoff request');
        if(this.action === 'edit') {
            dialogTitle = this.utilityService.getLocaleValue('edit.time.off.dialog.title', 'Edit Timeoff request');
        }
        return dialogTitle;
    }

    ngOnDestroy(): void {
        this.datePickerSubscription.unsubscribe();
        this.timePickerSubscription.unsubscribe();
        this.toTimePickerSubscription.unsubscribe();
        this.endDatePickerSubscription.unsubscribe();
    }
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function endTimeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control?.parent) {
            const startTime = control.parent.controls?.['from_time_picker'].value;
            const endTime = control.parent.controls?.['to_time_picker'].value;
            const startDate = control.parent.controls?.['from_date'].value;
            const endDate = control.parent.controls?.['to_date'].value;
            const validationResult: any = {};
            if (!startTime || !endTime) {
                return null;
            }
            const startTimeObject = moment(startDate.format('YYYY-MM-DD') + ' ' + startTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
            const endTimeObject = moment(endDate.format('YYYY-MM-DD') + ' ' + endTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
            const invalidEndTime = endTimeObject.isSameOrBefore(startTimeObject);
            if (invalidEndTime) {
                validationResult['invalidEndTime'] = true;
            }
            else {
                delete validationResult['invalidEndTime'];
            }
            return invalidEndTime ? validationResult : null;
        }
        else {
            return null;
        }
    };
}
